import { Button, Modal } from '@/components/ui'

export type CheckinAction = 'cancel' | 'reset'

const COPY: Record<
  CheckinAction,
  { title: string; body: string; confirm: string }
> = {
  cancel: {
    title: 'Cancel check-in',
    body:
      'The current check-in will be cancelled and a new one created in its place. ' +
      'The ticket owner will be emailed, and any wristband or facial-access enrollment ' +
      'linked to this check-in will be revoked. This cannot be undone.',
    confirm: 'Cancel check-in',
  },
  reset: {
    title: 'Reset check-in status',
    body:
      'The check-in will move back to NOT_STARTED. The details the owner submitted — ' +
      'including their photo and any guardian details — will be discarded, and they ' +
      'will have to fill the check-in in again. This cannot be undone.',
    confirm: 'Reset status',
  },
}

export interface CheckinActionModalProps {
  open: boolean
  action: CheckinAction
  loading?: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
}

export function CheckinActionModal({
  open,
  action,
  loading,
  onOpenChange,
  onConfirm,
}: CheckinActionModalProps) {
  const copy = COPY[action]

  return (
    <Modal
      open={open}
      onOpenChange={onOpenChange}
      size="sm"
      title={copy.title}
      footer={
        <div className="flex gap-3 justify-end w-full">
          <Button
            variant="primary-bordered"
            size="sm"
            disabled={loading}
            onClick={() => onOpenChange(false)}
          >
            Keep as is
          </Button>
          <Button size="sm" disabled={loading} onClick={onConfirm}>
            {copy.confirm}
          </Button>
        </div>
      }
    >
      <p className="text-body-m px-[30px] pb-4">{copy.body}</p>
    </Modal>
  )
}
